// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1L6bT","list":"BalanceDue_list__2OdrH","listRow":"BalanceDue_listRow__r1SuV","total":"BalanceDue_total__3XF6i"};